// PROD BUILD ENV
declare global {
  interface Window { env: any; }
}

window.env = window.env || {};

export const environment = {
  production: window.env.production || false,
  useStaticAPIData: window.env.useStaticAPIData || false,
  apiVersion: window.env.apiVersion || 'v1/',
  uriEndpoint: window.env.uriEndpoint || '',
  uriCSEndpoint: window.env.uriCSEndpoint || '',
  uriTTPEndpoint: window.env.uriTTPEndpoint || '',
  underMaintenance : window.env.underMaintenance || false,

  returnUrls: window.env.returnUrls || {
    'ttp-external': window.env.TTP_EXT_RETURN_URL || '',
    'ttp-external-scheduler': window.env.TTP_EXT_SCHED_RETURN_URL || '',
    'ttp-internal': window.env.TTP_INTERNAL_RETURN_URL || ''
  },

  'APP_BASE': '/schedulerui/',
  'REMOTE_LOCATION_ID': 999999999
};
